export const CAPACITY_FINDER_CHANGE_TRACKING = {
  searchCarriers: {
    source: 'capacity_finder.search_carriers',
    id: 12414,
  },
  searchLoad: {
    source: 'capacity_finder.search_load',
    id: 12437,
  },
} as const;
